/**
 * Der einmalige Aufbau der Arbeitsfläche nach der Anmeldung.
 *
 * Nach dem Anmelden soll sich die Konsole sichtbar aufbauen — einmal. Beim
 * nächsten Bereichswechsel, beim Neuladen, beim Zurückkommen aus dem Adminbereich
 * nicht mehr. Eine Animation, die man zehnmal am Tag sieht, ist keine Begrüßung
 * mehr, sondern eine Wartezeit.
 *
 * ── Warum sessionStorage und kein Zustand im Store ──
 * Zwischen „Anmeldung erfolgreich" und „Konsole gerendert" liegt ein
 * Routenwechsel, und in manchen Fällen lädt der Browser die Seite dabei neu
 * (SSO-Rückweg, erzwungener Passwortwechsel). Ein Wert im React-Zustand wäre
 * dann weg. `sessionStorage` überlebt das, endet aber mit dem Tab — genau die
 * Lebensdauer einer Anmeldung.
 *
 * ── Warum beim Lesen gelöscht wird ──
 * Der Merker ist eine Einmalfahrkarte. Wer ihn nur liest und stehen lässt, löst
 * die Animation beim nächsten Mounten erneut aus — und das passiert in React
 * öfter, als man denkt.
 */

const SCHLUESSEL = 'asd:willkommensauftritt';

/** Nach erfolgreicher Anmeldung setzen. */
export function merkeAnmeldung(): void {
  try {
    sessionStorage.setItem(SCHLUESSEL, '1');
  } catch {
    // Privater Modus oder gesperrter Speicher: Dann gibt es eben keinen Auftritt.
    // Das ist ein Schmuckstück, kein Bestandteil der Anmeldung.
  }
}

/**
 * Einmalig abfragen und verbrauchen.
 *
 * Liefert `false`, wenn der Benutzer reduzierte Bewegung eingestellt hat — der
 * Merker wird trotzdem verbraucht, sonst wartete er auf den nächsten Mount und
 * die Fläche bliebe unnötig lange leer.
 */
export function verbraucheAnmeldung(): boolean {
  let gesetzt = false;
  try {
    gesetzt = sessionStorage.getItem(SCHLUESSEL) === '1';
    if (gesetzt) sessionStorage.removeItem(SCHLUESSEL);
  } catch {
    return false;
  }
  if (!gesetzt) return false;

  if (typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
    return false;
  }
  return true;
}
